import { Typography, ButtonBase } from "@mui/material"
import { Button, SvgIcon, type FC } from ".."

interface TripCTAProps {
  buttonText?: string
  onClick?: () => void
}

const TripCTA: FC<TripCTAProps> = ({ buttonText = "Start Your Quote", onClick }) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={(theme) => ({
        ...theme.typography["link.md"],
        "display": "flex",
        "alignItems": "center",
        "gap": 2,
        "minHeight": 44,
        "padding": theme.spacing(2, 4),
        "backgroundColor": theme.palette["primary.800"].main,
        "borderRadius": 1,
        "lineHeight": 1,
        "transition": theme.transitions.create(["background-color", "border-color", "color"]),
        "&:hover": {
          backgroundColor: theme.palette["primary.900"].main,
        },
      })}
    >
      <Typography
        variant="body.md"
        fontWeight={600}
        sx={(theme) => ({
          color: theme.palette["neutral.100"].main,
        })}
      >
        {buttonText}
      </Typography>
      <SvgIcon
        viewBox="0 0 17 16"
        variant="arrowRight"
        strokeMode
        size={14}
        sx={(theme) => ({
          transition: theme.transitions.create(["transform"]),
          stroke: theme.palette["neutral.100"].main,
        })}
      />
    </ButtonBase>
  )
}

export default TripCTA
